const setVhWihtoutURLBar = () => {
  const vh = window.innerHeight * 0.01
  document.documentElement.style.setProperty('--vh', `${vh}px`)
}

export const initVhWithoutURLBar = () => {
  setVhWihtoutURLBar()
  window.addEventListener('resize', () => setVhWihtoutURLBar())
}
